// src/components/DashboardCard.jsx
import React from 'react';

const DashboardCard = ({ dashboard, onOpen }) => {
  return (
    <div className="dashboard-card">
      <img
        src={dashboard.image_url || '/fallback.png'}
        alt={dashboard.dashboard_name}
        className="dashboard-image"
        style={{ width: '150px', height: '150px', objectFit: 'contain' }}
      />

      <h3>{dashboard.dashboard_name}</h3>

      <button
        onClick={() => {
          console.log('Clicked dashboard (public_uuid):', dashboard.public_uuid);
          onOpen(dashboard.public_uuid);
        }}
      >
        Open
      </button>
    </div>
  );
};

export default DashboardCard;